export const resolvePageList = () => {
  return [ 'pageContentService', pageContentService => {
    return pageContentService.list();
  }];
};

export const resolveAdminPageList = () => {
  return [ 'pageContentService', pageContentService => {
    return pageContentService.adminList();
  }];
};

export const resolveEmailPageList = () => {
  return [ 'pageContentService', pageContentService => {
    return pageContentService.emailList();
  }];
};

export const resolvePageContent = (param = 'page') => {
  return [ '$stateParams', 'pageContentService', ($stateParams, pageContentService) => {
    return pageContentService.find($stateParams[param]);
  }];
};
export const resolveAdminPageContent = (param = 'page') => {
  return [ '$stateParams', 'pageContentService', ($stateParams, pageContentService) => {
    return pageContentService.findAdmin($stateParams[param]);
  }];
};


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/resolvers/pageContent.resolver.js